module.exports = __webpack_public_path__ + "static/blog16-ed6c300fb960d23a94654e5330eac901.png";